export const normalizePatientHn = (value = "") =>
  String(value == null ? "" : value).replace(/\s+/g, "");

export const getPatientPagePath = (hn) =>
  `/patient-page/${normalizePatientHn(hn)}`;
